import React from 'react';
import { Phone } from 'lucide-react';

type Props = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
};

export default function AuthSplitLayout({ title, subtitle, children }: Props) {
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      {/* Left: form */}
      <div className="flex items-center justify-center bg-white px-6 py-12">
        <div className="w-full max-w-md">
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {subtitle ? <p className="mt-2 text-sm text-gray-600">{subtitle}</p> : null}
          <div className="mt-8">{children}</div>
        </div>
      </div>

      {/* Right: brand panel */}
      <div className="hidden lg:flex items-center justify-center bg-gradient-to-br from-green-600 to-green-800 px-10 py-12">
        <div className="max-w-md text-white">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-white/15 rounded-lg flex items-center justify-center">
              <Phone className="w-7 h-7 text-white" />
            </div>
            <div>
              <div className="text-2xl font-bold">Patient Support Wizard</div>
              <div className="text-white/80 text-sm">Patient engagement & support</div>
            </div>
          </div>

          <p className="mt-8 text-white/90 leading-relaxed">
            A unified workspace to support patients with appointments, reminders, education,
            and contact-centre visibility.
          </p>

          <div className="mt-6 text-white/80 text-sm">
            Sign in to continue.
          </div>
        </div>
      </div>
    </div>
  );
}
